// extracted by mini-css-extract-plugin
module.exports = {"contact-request__overview__content__tax-list__item":"TaxRates_contact-request__overview__content__tax-list__item__WpRsQ"};